/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ThumbsUpIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="thumbs-up"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M7.6 11L7.6 15.2L7.6 17.4C7.6 18.505 8.495 19.4 9.6 19.4L17.163 19.4C18.07 19.4 18.862 18.791 19.096 17.915L20.429 12.915C20.768 11.646 19.811 10.4 18.497 10.4L16.8 10.4C15.695 10.4 14.8 9.505 14.8 8.4L14.8 6.2C14.8 5.206 13.994 4.4 13 4.4C12.006 4.4 11.2 5.206 11.2 6.2L11.2 8L11.2 9C11.2 10.105 10.305 11 9.2 11L7.6 11" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.2 11L7 11L5.4 11C4.295 11 3.4 11.895 3.4 13L3.4 16.8C3.4 17.905 4.295 18.8 5.4 18.8L5.6 18.8C6.705 18.8 7.6 17.905 7.6 16.8L7.6 15.2" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
